import API from "../../../../app/api";

/**
 * Get products by category / subcategory
 */
export const getSearchProducts = async ({
    page = 1,
    limit = 40,
    q = "",
    filters = {},
}) => {
    const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
    });
    //  Add search query if exists
    if (q && q.trim() !== "") {
        params.append("q", q.trim());
    }
    Object.entries(filters).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
            params.append(key, value.join(","));
        } else if (value !== undefined && value !== null && value !== "") {
            params.append(key, String(value));
        }
    });

    const response = await API.get(`/promotional/search?${params.toString()}`);
    return response.data.data;
};

/**
 * Get PLP bottom banner
 */
export const getPLPBottomBanner = async () => {
    try {
        const res = await API.get("/banners/product-listing-bottom");
        return res;
    } catch (error) {
        console.error("getPLPBottomBanner failed:", error);
        throw (
            error.response?.data ||
            new Error("Failed to fetch PLP bottom banner")
        );
    }
};

/**
 * Get Best Seller banner
 */
export const getBestSellerBanner = async () => {
    try {
        const res = await API.get("/bestsellers/banner");
        return res.data;
    } catch (error) {
        console.error("getBestSellerBanner failed:", error);
        throw (
            error.response?.data ||
            new Error("Failed to fetch bestseller banner")
        );
    }
};
